import { Flag, useFlag } from '@crocodille/common';
import CopyIcon from '@components/icons/copy-icon';
import { isSome, Maybe } from '@crocodille/util';
import cn from 'classnames';
import React, { useCallback } from 'react';
import { postMessageToWebView } from 'src/modules/webview';

import styles from './copy-area.module.scss';

export interface Props {
  readonly label?: Maybe<string>;
  readonly children: string;
  readonly className?: string;
}

const CopyArea: React.FC<Props> = ({ children, label, className }) => {
  const handleFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select?.();
    e.target.setSelectionRange(0, e.target.value.length);
  }, []);

  const isInWebView = useFlag(Flag.IS_IN_WEBVIEW);

  const handleCopyClick = useCallback(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (isInWebView) {
      postMessageToWebView({ action: 'copyToClipboard', text: children });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(children);
    }
  }, [children, isInWebView]);

  return (
    <div className={cn(styles.container, className)}>
      <label className={styles.inputContainer}>
        {isSome(label) ? <span className={styles.label}>{label}</span> : null}
        <input
          className={styles.input}
          type="text"
          value={children}
          onFocus={handleFocus}
          readOnly
        />
      </label>
      <button
        type="button"
        className={styles.copyButton}
        onClick={handleCopyClick}
      >
        <CopyIcon />
      </button>
    </div>
  );
};

export default CopyArea;
